import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import MainContentDealSmartWatch from './MainContentDealSmartWatch'



const LayoutDealSmartWatch = () => {

 

  return (
    <div className='page-deal-smart-watch'>
        <MainContentDealSmartWatch />
    </div>
  )
}

export default LayoutDealSmartWatch 
